<!-- App.vue (Root)  -->
<template>
  <div id="app">
    <ToastManager />
    <router-view :key="$route.params.id"></router-view>
  </div>

</template>

<script>
import ToastManager from '@/components/ToastManager.vue'
export default {
  name: 'App',
  components: {
    ToastManager
  },
  created() {
    // 捕捉 ?ref=CODE 推廣碼，永久存入 localStorage（第一次下單後由伺服器把歸屬綁定到會員帳號，之後終身有效）
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      localStorage.setItem('affiliateRef', JSON.stringify({ code: ref }));
    }
  }
}
</script>
